import { gridActions } from "../../../actions/grid.actions";
import { useAppDispatch } from "../../../effects/useAppDispatch";
import { useAppSelector } from "../../../effects/useAppSelector";
import { GridDataItem } from "../../../types/state/GridState";
import { EditingInventoryPosition } from "../../../types/state/InventoryEditState";
import { Pluralize } from "../../common/Pluralize";
import { Checkbox } from "../../controls/Checkbox";

interface Props {
    disabled?: boolean
}
export function PrivateInventoryButton({ disabled = false }: Props) {
    const dispatch = useAppDispatch();
    const hasDataItems = useAppSelector(s => s.grid.dataItems.some((x: GridDataItem<EditingInventoryPosition>) => !x.draft));
    const privateSecurityCount = useAppSelector(s => s.grid.dataItems.filter((x: GridDataItem<EditingInventoryPosition>) =>
        !x.draft && x.isPrivate).length);
    const hasPrivate = privateSecurityCount > 0;
    const hasPublic = useAppSelector(s => s.grid.dataItems.some((x: GridDataItem<EditingInventoryPosition>) =>
        !x.draft && !x.isPrivate));

    return (
        <>
            <Checkbox
                checked={hasPrivate}
                disabled={!hasDataItems || disabled}
                partially={hasPrivate && hasPublic}
                onChange={e => dispatch(gridActions.updateColumnValue('isPrivate', hasPrivate === hasPublic ? true : !hasPrivate))}
            >
                Make All Private
            </Checkbox>
            {hasPrivate && (
                <div className="private-number">
                    Private - <Pluralize singular="security" plural="securities" count={privateSecurityCount} />
                </div>
            )}
        </>
    );
}